import { render, staticRenderFns } from "./ZDMFailureReportAdmin.vue?vue&type=template&id=22e653d1&scoped=true&"
import script from "./ZDMFailureReportAdmin.vue?vue&type=script&lang=js&"
export * from "./ZDMFailureReportAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e653d1",
  null
  
)

export default component.exports